var $7cc6d0d862c228e8$exports = {};
$7cc6d0d862c228e8$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdb\u{11B}r barvy`,
    "colorSwatch": `barevn\xfd vzorek`,
    "transparent": `pr\u{16F}hledn\xfd`,
    "twoDimensionalSlider": `2D posuvn\xedk`
};


export {$7cc6d0d862c228e8$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
